// extracted by css-extract-rspack-plugin
export default {"queryResizableBox":"k7EnL","nativeResizableBox":"L8fPm"};